if (!customElements.get('virtual-townhouse')) {
  customElements.define(
    'virtual-townhouse',
    class VirtualTownhouse extends window.BAO.CustomElement {
      constructor () {
        super()

        this.zoomToRoom = this.zoomToRoom.bind(this)
        this.zoomOut = this.zoomOut.bind(this)
        this.setRolloverModalContent = this.setRolloverModalContent.bind(this)
      }

      setupListeners () {
        super.setupListeners()

        if (this.els?.room?.exists) {
          this.els.room.elements.forEach(roomEl => {
            this.listeners.add(roomEl, 'click', this.zoomToRoom)
          })
        }

        if (this.els?.modalClose?.exists) {
          this.els.modalClose.elements.forEach(roomEl => {
            this.listeners.add(roomEl, 'click', this.zoomOut)
          })
        }

        if (this.els?.rollover?.exists) {
          this.els.rollover.elements.forEach(rolloverEl => {
            this.listeners.add(rolloverEl, 'click', this.zoomOut)
          })
        }
      }

      zoomToRoom (e) {
        e.preventDefault()
        e.stopPropagation()

        const room = e.currentTarget
        this.els.room.elements.forEach(roomEl => {
          roomEl.setAttribute('aria-selected', 'false')
        })
        room.setAttribute('aria-selected', 'true')

        const dot = room.querySelector('.sec-Townhouse_Dot')
        const x = dot.offsetLeft
        const y = dot.offsetTop

        const scriptTag = room.querySelector('script')
        const content = JSON.parse(scriptTag.innerText)
        this.setRolloverModalContent(content)

        this.els.rollover.element.style.transformOrigin = `${x}px ${y}px`
        this.els.rollover.element.style.transform = 'scale(2.5)'

        this.els.rollover.element.classList.add('sec-Townhouse_Rollover-zoomed')
        this.els.modal.element.classList.add('sec-Townhouse_Modal-open')
      }

      setRolloverModalContent (content) {
        this.els.modalTitle.element.innerText = content.title
        this.els.modalTitle.element.style.display = content.title
          ? 'block'
          : 'none'

        this.els.modalText.element.innerHTML = content.text
        this.els.modalText.element.style.display = content.title
          ? 'block'
          : 'none'

        this.els.modalImage.element.src = content.image
        this.els.modalImage.element.style.display = content.image
          ? 'block'
          : 'none'

        this.els.modalButton.element.innerText = content.button.text
        this.els.modalButton.element.setAttribute('href', content.button.url)
        this.els.modalButton.element.style.display =
          !!content.title && !!content.button.url ? 'inline-block' : 'none'
      }

      zoomOut () {
        this.els.rollover.element.classList.remove(
          'sec-Townhouse_Rollover-zoomed',
        )
        this.els.modal.element.classList.remove('sec-Townhouse_Modal-open')

        this.els.rollover.element.style.transform = 'scale(1)'

        this.els.room.elements.forEach(roomEl => {
          roomEl.setAttribute('aria-selected', 'false')
        })
      }
    },
  )
}
